// src/i18n/privacy/index.js

import en from './privacy.en.json';
import ru from './privacy.ru.json';
import zh from './privacy.zh.json';
import es from './privacy.es.json';
import de from './privacy.de.json';
import fr from './privacy.fr.json';
import ja from './privacy.ja.json';
import hi from './privacy.hi.json';
import pt from './privacy.pt.json';
import ko from './privacy.ko.json';
import it from './privacy.it.json';
import kk from './privacy.kk.json';

/**
 * Все переводы политики конфиденциальности по языкам.
 * Ключи: en, ru, zh, es, de, fr, ja, hi, pt, ko, it, kk
 */
export const privacyTranslations = {
  en,
  ru,
  zh,
  es,
  de,
  fr,
  ja,
  hi,
  pt,
  ko,
  it,
  kk,
};

/**
 * Нормализация кода языка:
 *  - 'en-US' → 'en-us'
 *  - 'en-us' и 'en-GB' → пробуем как есть, потом 'en'
 *  - если ничего не нашли → 'en'
 */
export function normalizePrivacyLang(lang) {
  if (!lang) return 'en';

  const lower = String(lang).toLowerCase();
  const base = lower.split('-')[0];

  if (privacyTranslations[lower]) return lower;
  if (privacyTranslations[base]) return base;

  return 'en';
}

/**
 * Вернуть объект политики для нужного языка.
 * Пример:
 *   const privacy = getPrivacy('ru');
 *   console.log(privacy['privacy.header.title']);
 */
export function getPrivacy(lang) {
  const code = normalizePrivacyLang(lang);
  return privacyTranslations[code] || privacyTranslations.en;
}

/**
 * Вернуть конкретную строку по ключу.
 * Если ключ не найден — вернётся сам ключ (удобно для отладки).
 *
 * Пример:
 *   const title = getPrivacyText('ru', 'privacy.header.title');
 */
export function getPrivacyText(lang, key) {
  const bundle = getPrivacy(lang);
  if (!bundle || !key) return key;

  if (Object.prototype.hasOwnProperty.call(bundle, key)) {
    return bundle[key];
  }

  const trimmed = key.trim();
  if (
    trimmed !== key &&
    Object.prototype.hasOwnProperty.call(bundle, trimmed)
  ) {
    return bundle[trimmed];
  }

  return key;
}
